// From the api's answers about the caller to what the header shows. Pure.
import type { components } from "../../api/schema";
import type { User } from "../../data/mock";

export type Me = components["schemas"]["Me"];

// the rule of the avatar's letters lives in src/lib/initials.ts: the cards use it for the organisation too
import { initialsOf } from "../../lib/initials";

export { initialsOf };

export function toUser(me: Me): User {
  return { name: me.display_name, email: me.upn, initials: initialsOf(me.display_name) };
}

/**
 * Whether the new search (F07) is on for the caller: `features.search_v2` of
 * /me. Anything but a true answer (no answer yet, a failed /me, a /me without
 * `features`) keeps the page of today, «In sviluppo».
 */
export function hasSearchV2(me: Me | undefined): boolean {
  // `features` is absent in the /me of a Loggione from before the switch (a rollback, or Platea first)
  return me?.features?.search_v2 === true;
}

/** The Entra end-session address from POST /auth/logout: an http(s) URL, else null. */
export function logoutUrlOf(body: unknown): string | null {
  if (typeof body !== "object" || body === null || !("logout_url" in body)) return null;
  const value = body.logout_url;
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:" ? url.href : null;
  } catch {
    return null;
  }
}
